import React, { useState } from "react";

const FALLBACK_IMAGE =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'><rect width='100%25' height='100%25' fill='%23e9ecef'/><text x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%236c757d' font-family='Arial, sans-serif' font-size='36'>Image unavailable</text></svg>";

export default function SafeImage({ src, alt, ...props }) {
  const [failed, setFailed] = useState(false);
  const safeSrc = !failed && src ? src : FALLBACK_IMAGE;

  return (
    <img
      src={safeSrc}
      alt={alt || "Image"}
      onError={() => setFailed(true)}
      {...props}
    />
  );
}
